/*
  Lata bilder med data-defer-src (snippets/image.liquid) får sin src först
  efter load, eller tidigare om de närmar sig skärmen. Bilder som läggs till
  senare (filter, sidbyte, rekommendationer) laddas direkt.
*/
(function () {
  var SELECTOR = 'img[data-defer-src]';
  var loaded = false;

  function reveal(img) {
    if (!img.hasAttribute('data-defer-src')) return;
    if (img.dataset.deferSrcset) {
      img.srcset = img.dataset.deferSrcset;
      img.removeAttribute('data-defer-srcset');
    }
    img.src = img.dataset.deferSrc;
    img.removeAttribute('data-defer-src');
  }

  function revealWithin(root) {
    if (root.matches && root.matches(SELECTOR)) reveal(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(reveal);
  }

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.unobserve(entry.target);
          reveal(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });
  }

  function observeAll() {
    if (!io) return;
    document.querySelectorAll(SELECTOR).forEach(function (img) { io.observe(img); });
  }

  function revealAll() {
    loaded = true;
    if (io) io.disconnect();
    revealWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  if (document.readyState === 'complete') {
    revealAll();
  } else {
    window.addEventListener('load', revealAll);
  }

  // Innehåll som byts ut efter load (filter, sidbyte, AJAX-sektioner).
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      if (!loaded) return;
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches(SELECTOR) || (node.firstElementChild && node.querySelector(SELECTOR)))) {
            revealWithin(node);
          }
        });
      });
    }).observe(document.documentElement, { subtree: true, childList: true });
  }
})();
